function dateFormat (date, fmt) {
  if (!fmt) {
    fmt = "yyyy-MM-dd HH:mm:ss";
  }
  let ret;
  const opt = {
    "y+": date.getFullYear().toString(), // 年
    "M+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "m+": date.getMinutes().toString(), // 分
    "s+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
function getType (obj) {
  //tostring会返回对应不同的标签的构造函数
  const toString = Object.prototype.toString;
  const map = {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object",
  };
  if (obj instanceof Element) {
    return "element";
  }
  return map[toString.call(obj)];
}

function deepClone (data) {
  var type = getType(data);
  var obj;
  if (type === "array") {
    obj = [];
  } else if (type === "object") {
    obj = {};
  } else {
    //不再具有下一层次
    return data;
  }
  if (type === "array") {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === "object") {
    for (var key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
}

function changeImgSize (url, size) {
  if (size) {
    var f = url.substring(0, url.lastIndexOf("."));
    var s = url.substring(url.lastIndexOf("."));
    url = f + "_" + size + "x" + size + s;
  }
  return url;
};

function businessModelDesc (businessModel) {
  if (businessModel == 22) {
    return "日结转月结"
  } else if (businessModel == 23) {
    return "日结"
  } else if (businessModel == 24) {
    return "月结(30天)"
  } else if (businessModel == 25) {
    return "月结(自然月)"
  } else if (businessModel == 27) {
    return "周结"
  }
  return "未配置"
};

function priceFormatter (source) {
  if (source) {
    if (source.businessModel == 22) {
      return source.prices.day + "/日，" + source.prices.month + "/月"
    } else if (source.businessModel == 23) {
      return source.prices.day + "/日"
    } else if (source.businessModel == 24 || source.businessModel == 25) {
      return source.prices.month + "/月"
    } else if (source.businessModel == 27) {
      return source.prices.week + "/周"
    }
  }
  return "未配置";
};

function hideName (name) {
  var newStr;
  if (name.length === 2) {
    newStr = name.substr(0, 1) + '*';
  } else if (name.length > 2) {
    var char = '';
    for (let i = 0, len = name.length - 2; i < len; i++) {
      char += '*';
    }
    newStr = name.substr(0, 1) + char + name.substr(-1, 1);
  } else {
    newStr = name;
  }
  return newStr
};

function hideIDCard (value) {
  return value.replace(/(.{6}).*(.{4})/, '$1********$2')
};

function getCurrentDate () {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours()
  let min = date.getMinutes()
  let second = date.getSeconds()
  function getZero (n) {
    let m = n > 10 ? n : "0" + n;
    return m;
  }
  return year + "年" + month + "月" + day + "日" + '' + hour + ":" + getZero(min) + ":" + getZero(second);
}

function convertStatus (status, type) {
  let result = ''
  switch (status) {
    case 1:
      result = '待审核';
      break;
    case 2:
      result = '已撤回';
      break;
    case 3:
      result = '等待电子签发起';
      break;
    case 4:
      result = '审批拒绝';
      break;
    case 5:
      result = '等待承租商签署';
      break;
    case 6:
      result = '等待租赁商签署';
      break;
    case 7:
      result = type == 'contract' ? '待进场' : '执行中';
      break;
    case 8:
      result = type == 'contract' ? '已归档' : '已完成';
      break;
    case 9:
      result = '已终止';
      break;
    case 10:
      result = '待结算';
      break;
    case 11:
      result = '待结清';
      break;
    case 12:
      result = '已结清';
      break;
  }
  return result
}

function convertColor (status, type) {
  if (status == 2 || status == 4 || status == 9) {
    return 'border: 1px solid rgb(255, 137, 137);color: rgb(255, 137, 137);'
  } else if (status == 3 || status == 12) {
    return 'border: 1px solid #32B726;color: #32B726;';
  } else if (status == 7) {
    return 'border: 1px solid #0096FF;color: #0096FF;';
  } else if (status == 8 && type == 'contract') {
    return 'border: 1px solid #C9CDD4;color: #C9CDD4;';
  } else if (status == 8 && type == 'other') {
    return 'border: 1px solid #0096FF;color: #0096FF;';
  } else {
    return 'border: 1px solid #F3A40B;color: #F3A40B;'
  }
}

function isAndroidOrIOS () {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  if (isAndroid) {
    return 'android'
  }
  if (isiOS) {
    return 'ios'
  }
  return false
};

// 回退逻辑
function isFromApp () {
  // 检查URL中是否含有特定参数或scheme
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('from_app')
}

/**
 * 1、app->列表、详情=第一层级；store.dispatch('firstPage');
 * 2、app->列表->详情=第二层级；详情页需要设置store.dispatch('secondPage');满足详情->列表->app
 * 3、H5内操作，返回上一页
 */
function historyBack (store) {
  const historyLevel = store.state.historyLevel
  console.log('返回', historyLevel)
  if (historyLevel === 2) {
    store.dispatch('firstPage');
    history.back()
  } else if (historyLevel === 1 && isFromApp()) {
    quit()
  } else {
    store.dispatch('initPage');
    history.back()
  }
}

// 返回到APP首页
function quit () {
  if ((window.highMachine && typeof window.highMachine.navigateTo === 'function') || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.navigateTo)) {
    if (isAndroidOrIOS() == 'android') {
      window.highMachine.quit();
    } else if (isAndroidOrIOS() == 'ios') {
      window.webkit.messageHandlers.quit.postMessage(null);
    }
  } else {
    history.back()
  }
}

function callPhone (phone) {
  if (isAndroidOrIOS() == 'android') {
    window.location.href = 'tel://' + phone;
  } else if (isAndroidOrIOS() == 'ios') {
    window.webkit.messageHandlers.callPhone.postMessage(phone);
  }
}

function formatTimeDiff (timestamp) {
  const now = new Date();
  const timeDiff = now - new Date(timestamp); // 时间差，单位为毫秒

  const seconds = Math.floor(timeDiff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return `${seconds}秒前`;
  } else if (minutes < 60) {
    return `${minutes}分钟前`;
  } else if (hours < 24) {
    return `${hours}小时前`;
  } else {
    const date = new Date(timestamp);
    const month = date.getMonth() + 1; // 月份从0开始
    const day = date.getDate();
    return `${month}-${day}`;
  }
}

// android预览跳内部浏览器，签署使用previewUrl
function previewUrl (url) {
  if (isAndroidOrIOS() == 'android') {
    // window.location.href = url
    window.highMachine.previewUrl(url);
  } else if (isAndroidOrIOS() == 'ios') {
    window.webkit.messageHandlers.previewUrl.postMessage(url);
  }
}

// 预览本地PDF文件
function previewPdf (name, url) {
  if (isAndroidOrIOS() == 'android') {
    window.highMachine.previewPdf(name, url);
  } else if (isAndroidOrIOS() == 'ios') {
    window.webkit.messageHandlers.previewUrl.postMessage(url);
  }
}

// 证件类型
function getIdCardType (val, type) {
  let result = ''
  if (type == 'person') {
    switch (val) {
      case 1:
        result = '身份证'
        break;
      case 2:
        result = '泰国身份证'
        break;
      default:
        result = '身份证';
    }
  } else {
    switch (val) {
      case 1:
        result = '营业执照'
        break;
      case 2:
        result = '泰国执照'
        break;
      default:
        result = '营业执照';
    }
  }
  return result
}

// 证件号
function getIdCardName (val, type) {
  let result = ''
  if (type == 'person') {
    switch (val) {
      case 1:
        result = '身份证号';
        break;
      case 2:
        result = '证件号';
        break;
      default:
        result = '证件号';
    }
  } else {
    switch (val) {
      case 1:
        result = '统信码';
        break;
      case 2:
        result = '税号';
        break;
      default:
        result = '统信码';
    }
  }
  return result
}

// 审批状态
function coverToApprovalStatus (status) {
  let result = {
    text: '',
    type: ''
  };
  switch (status) {
    case 1:
      result = {
        text: '待审批',
        type: 'warning',
      };
      break;
    case 2:
      result = {
        text: '草稿',
        type: 'primary'
      };
      break;
    case 3:
      result = {
        text: '审批通过',
        type: 'success'
      };
      break;
    case 4:
      result = {
        text: '审批拒绝',
        type: 'danger'
      };
      break;
    case 5:
      result = {
        text: '等待承租方签署',
        type: 'warning'
      };
      break;
    case 6:
      result = {
        text: '等待租赁方签署',
        type: 'warning'
      };
      break;
    case 7:
      result = {
        text: '执行中',
        type: 'success'
      };
      break;
    case 8:
      result = {
        text: '已完成',
        type: 'primary'
      };
      break;
    case 9:
      result = {
        text: '已终止',
        type: 'danger'
      };
      break;
  }
  return result
}

function getFlowPoint (process) {
  let url = ''
  switch (process.flowCategoryCode) {
    case 'SP_Contract':
    case 'DZQ_Contract':
      url = `/contract/details?tab=a&cid=${process.id}`
      break;
    case 'SP_EntryOrder':
    case 'DZQ_EntryOrder':
      url = `/entry/details?eoid=${process.id}`
      break;
    case 'SP_QuitOrder':
    case 'DZQ_QuitOrder':
      url = `/quit/details?qoid=${process.id}`
      break;
    case 'SP_BillingRecord':
    case 'DZQ_BillingRecord':
      url = `/billList/detail?brid=${process.id}`
      break;
    case 'SP_SettlementRecord':
    case 'DZQ_SettlementRecord':
      url = `/settleBill/detail?srid=${process.id}`
      break;
    case 'SP_ClearanceRecord':
    case 'DZQ_ClearanceRecord':
      url = `/settleUp/detail?id=${process.id}`
      break;
    case 'SP_Receipt':
    case 'DZQ_Receipt':
      url = `/contract/details?tab=h&cid=${process.contractId}`
      break;
    case 'SP_Claim':
    case 'DZQ_Claim':
      url = `/claim/detail?id=${process.id}&cid=${process.contractId}`
      break;
    case 'SP_DeactivateRecord':
      url = `/devStop/detail?drid=${process.id}&cid=${process.contractId}`
      break;
    case 'SP_Invoice':
      url = `/invoice/detail?id=${process.id}`
      break
    case 'SP_SubleaseRecord':
      url = `/subLeaseMng/subRecordDetail?srid=${process.id}`
      break;
    case 'SP_ContractChange':
      url = `/contractChange/detail?id=${process.id}`
      break;
    default:
      url = ''
  }
  return url
}

// 获取时间戳
function getTimestamp (date) {
  if (Array.isArray(date)) {
    return [new Date(date[0] + 'T00:00:00').getTime(), new Date(date[1] + 'T00:00:00').getTime()]
  }
  return new Date(date + 'T00:00:00').getTime()
}

// 合同状态转换
function convertStatus2 (status, type) {
  let result = {
    text: '',
    type: ''
  };
  switch (status) {
    case 1:
      result = {
        text: '待审核',
        type: 'warning',
      };
      break;
    case 2:
      result = {
        text: '已撤回',
        type: 'danger',
      };
      break;
    case 3:
      result = {
        text: '等待电子签发起',
        type: 'warning',
      };
      break;
    case 4:
      result = {
        text: '审批拒绝',
        type: 'danger',
      };
      break;
    case 5:
      result = {
        text: '等待承租商签署',
        type: 'warning',
      };
      break;
    case 6:
      result = {
        text: '等待租赁商签署',
        type: 'warning',
      };
      break;
    case 7:
      result = {
        text: type == 'contract' ? '待进场' : '执行中',
        type: 'primary',
      };
      break;
    case 8:
      result = {
        text: type == 'contract' ? '已归档' : '已完成',
        type: 'primary',
      };
      break;
    case 9:
      result = {
        text: '已终止',
        type: 'danger',
      };
      break;
    case 10:
      result = {
        text: '待结算',
        type: 'warning',
      };
      break;
    case 11:
      result = {
        text: '待结清',
        type: 'warning',
      };
      break;
    case 12:
      result = {
        text: '已结清',
        type: 'success',
      };
      break;
  }
  return result
}

// 电子签状态转换
function coverToSignStatus (status) {
  let result = {
    text: '',
    type: ''
  };
  switch (status) {
    case 1:
      result = {
        text: '---',
        type: 'primary'
      };
      break;
    case 2:
      result = {
        text: '等待电子签发起',
        type: 'warning'
      };
      break;
    case 3:
      result = {
        text: '等待承租方签署',
        type: 'warning'
      };
      break;
    case 4:
      result = {
        text: '等待租赁方签署',
        type: 'warning'
      };
      break;
    case 5:
      result = {
        text: '签署完成',
        type: 'success'
      };
      break;
    case 6:
      result = {
        text: '等待承租方作废签署',
        type: 'warning'
      };
      break;
    case 7:
      result = {
        text: '等待租赁方作废签署',
        type: 'warning'
      };
      break;
  }
  return result
}

exports.install = function (Vue, options) {
  Vue.config.globalProperties.dateFormat = dateFormat

  Vue.config.globalProperties.getType = getType

  Vue.config.globalProperties.deepClone = deepClone

  Vue.config.globalProperties.changeImgSize = changeImgSize

  Vue.config.globalProperties.businessModelDesc = businessModelDesc

  Vue.config.globalProperties.priceFormatter = priceFormatter

  Vue.config.globalProperties.isAndroidOrIOS = isAndroidOrIOS

  Vue.config.globalProperties.hideName = hideName

  Vue.config.globalProperties.hideIDCard = hideIDCard

  Vue.config.globalProperties.getCurrentDate = getCurrentDate

  Vue.config.globalProperties.convertColor = convertColor

  Vue.config.globalProperties.convertStatus = convertStatus

  Vue.config.globalProperties.historyBack = historyBack

  Vue.config.globalProperties.quit = quit

  Vue.config.globalProperties.callPhone = callPhone

  Vue.config.globalProperties.isFromApp = isFromApp

  Vue.config.globalProperties.formatTimeDiff = formatTimeDiff

  Vue.config.globalProperties.previewUrl = previewUrl
  Vue.config.globalProperties.previewPdf = previewPdf

  Vue.config.globalProperties.getIdCardType = getIdCardType

  Vue.config.globalProperties.getIdCardName = getIdCardName

  Vue.config.globalProperties.coverToApprovalStatus = coverToApprovalStatus

  Vue.config.globalProperties.getFlowPoint = getFlowPoint

  Vue.config.globalProperties.getTimestamp = getTimestamp
  Vue.config.globalProperties.coverToSignStatus = coverToSignStatus
  Vue.config.globalProperties.convertStatus2 = convertStatus2
};
